module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"powerBiReportingTitle":"Power BI Reporting"},"es":{"powerBiReportingTitle":"Informes Power BI"}}')
  delete Component.options._Ctor
}
